import { render, staticRenderFns } from "./AccountWalletDetailsLoader.vue?vue&type=template&id=bd7fafd8&scoped=true"
import script from "./AccountWalletDetailsLoader.vue?vue&type=script&lang=ts"
export * from "./AccountWalletDetailsLoader.vue?vue&type=script&lang=ts"
import style0 from "./AccountWalletDetailsLoader.vue?vue&type=style&index=0&id=bd7fafd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7fafd8",
  null
  
)

export default component.exports